<template>
  <Component
    :is="tag"
    :class="[
      inverted
        ? 'text-semantic-inverse-on-primary'
        : 'text-semantic-surface-on-surface',
      '[counter-reset:list-counter]',
    ]"
  >
    <li
      v-for="(item, index) in items"
      :key="index"
      class="not-last:mb-2 md:not-last:mb-4"
      :class="[
        bulletStyle,
      ]"
    >
      <V2IconsCheckCircle v-if="type === 'icon'" type="outline" />
      <span v-html="item" />
    </li>
  </Component>
</template>

<script setup>
defineOptions({
  name: 'V2AtomsList'
})

const props = defineProps({
  type: {
    type: String,
    default: 'unordered',
    validator: value => {
      return ['ordered', 'unordered', 'icon'].includes(value)
    }
  },
  inverted: {
    type: Boolean,
    default: false
  },
  items: {
    type: Array,
    default: () => []
  }
})

const tag = computed(() => {
  return props.type === 'ordered' ? 'ol' : 'ul'
})

const bulletStyle = computed(() => {
  const ordered =
    'list-none flex flex-row before:shrink-0 [counter-increment:list-counter] before:font-bold before:content-[counter(list-counter)] before:rounded-full md:before:w-6 md:before:h-6 before:w-5 before:h-5 before:text-center before:mr-3 md:text-base text-sm'
  const unordered = 'list-disc'
  const icon = 'list-none'

  return getKey(props.type, {
    ordered: props.inverted
      ? `${ordered} before:text-semantic-inverse-on-primary before:bg-semantic-inverse-primary`
      : `${ordered} before:text-semantic-inverse-on-surface before:bg-semantic-inverse-surface`,
    unordered: props.inverted
      ? `${unordered} marker:text-semantic-inverse-primary`
      : `${unordered} marker:text-semantic-inverse-surface`,
    icon: `${icon}`
  })
})
</script>
